/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Email_AlertsInputs */

const en_settings_email_alerts = /** @type {(inputs: Settings_Email_AlertsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email Alerts`)
};

const es_settings_email_alerts = /** @type {(inputs: Settings_Email_AlertsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alertas de correo`)
};

const fr_settings_email_alerts = /** @type {(inputs: Settings_Email_AlertsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alertes e-mail`)
};

const de_settings_email_alerts = /** @type {(inputs: Settings_Email_AlertsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-Mail-Benachrichtigungen`)
};

const ja_settings_email_alerts = /** @type {(inputs: Settings_Email_AlertsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メール通知`)
};

const zh_settings_email_alerts = /** @type {(inputs: Settings_Email_AlertsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`邮件提醒`)
};

const ar_settings_email_alerts = /** @type {(inputs: Settings_Email_AlertsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تنبيهات البريد الإلكتروني`)
};

const id_settings_email_alerts = /** @type {(inputs: Settings_Email_AlertsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Peringatan Email`)
};

const it_settings_email_alerts = /** @type {(inputs: Settings_Email_AlertsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avvisi via E-mail`)
};

const ru_settings_email_alerts = /** @type {(inputs: Settings_Email_AlertsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Уведомления по email`)
};

const pt_settings_email_alerts = /** @type {(inputs: Settings_Email_AlertsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alertas por E-mail`)
};

const ko_settings_email_alerts = /** @type {(inputs: Settings_Email_AlertsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이메일 알림`)
};

/**
* | output |
* | --- |
* | "Email Alerts" |
*
* @param {Settings_Email_AlertsInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const settings_email_alerts = /** @type {((inputs?: Settings_Email_AlertsInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Email_AlertsInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_email_alerts(inputs)
	if (locale === "es") return es_settings_email_alerts(inputs)
	if (locale === "fr") return fr_settings_email_alerts(inputs)
	if (locale === "de") return de_settings_email_alerts(inputs)
	if (locale === "ja") return ja_settings_email_alerts(inputs)
	if (locale === "zh") return zh_settings_email_alerts(inputs)
	if (locale === "ar") return ar_settings_email_alerts(inputs)
	if (locale === "id") return id_settings_email_alerts(inputs)
	if (locale === "it") return it_settings_email_alerts(inputs)
	if (locale === "ru") return ru_settings_email_alerts(inputs)
	if (locale === "pt") return pt_settings_email_alerts(inputs)
	return ko_settings_email_alerts(inputs)
});